<template>
	<div>

    <b-modal hide-footer
    id="modalPrevent2"
    ref="myModalRef5"
    title="Alert... !!!"
    ><div class="d-block text-center">
        <h3>Your stack has been freed</h3>
      </div>
      <b-button class="mt-3" variant="outline-danger" block @click="$refs.myModalRef5.hide()">Close Me</b-button>
    </b-modal>
      <b-modal hide-footer
      id="modalPrevent"
      ref="myModalRef1"
      title="Enter Details"
      @shown="clearName"
    >
    <div v-if="show">{{ status }}</div>
    <b-form @submit="onSubmit" @reset="onReset" >
      <b-form-group
        label="Enter purpose:"
      >
        <b-form-input
          type="text"
          v-model="form.purpose"
          required
          placeholder="Enter purpose" />
      </b-form-group>

      <b-form-group label="Your FrontendBranch:">
        <b-form-input
          type="text"
          v-model="form.FEBranch"
          required
          placeholder="Enter FrontendBranch" />
      </b-form-group>

      <b-form-group label="Your BackendBranch:" >
        <b-form-input
          type="text"
          v-model="form.BEBranch"
          required
          placeholder="Enter BackendBranch" />
      </b-form-group>

      <b-button type="submit"  variant="primary">Submit</b-button>
      <b-button type="reset" variant="danger">Reset</b-button>
    </b-form>
    </b-modal>
  <b-modal  hide-footer
      id="modalPrevent"
      ref="myModalRef"
      title="Enter Stack Name"
      @shown="clearNewName"
    >
      <form @submit.stop.prevent="handleSubmit">
        <b-form-input type="text" v-model="newstackname" placeholder="Stack Name" style="margin-bottom:20px;"/>
         <b-button align="center" variant="success" class="w-25 float-right" @click="addstacktodb">
          Add
        </b-button>
      </form>
    </b-modal>
  <b-container>
    <b-row class="box-container">
      <!-- <b-col> -->
        <section class="header-card">
        <h4 class="card-title">Stacks <b-button v-if="this.$session.get('role')=='admin'" size="sm" variant="success" class="w-10 float-right" @click="addstack">Create New</b-button></h4>
        <p class="card-category">Here listed the stacks </p>
        </section>
        <b-col md="6" class="my-1">
        <b-form-group label-cols-sm="3" label="Filter" class="mb-0">
          <b-input-group>
            <b-form-input v-model="filter" placeholder="Type to Search" />
            <b-input-group-append>
              <b-button :disabled="!filter" @click="filter = ''">Clear</b-button>
            </b-input-group-append>
          </b-input-group>
        </b-form-group>
      </b-col>

      <b-col md="6" class="my-1">
        <b-form-group label-cols-sm="3" label="Sort" class="mb-0">
          <b-input-group>
            <b-form-select v-model="filterget"  :options="sortOptions">
              <option slot="first" :value="none">-- none --</option>
            </b-form-select>
          </b-input-group>
        </b-form-group>
      </b-col>
        <b-table   striped class="hide-top-border app-normal-table "  
          stacked="md"
          :items="itemsstacks" 
          :fields="fieldsstack" 
          :current-page="currentPage"
          :per-page="5"
          :filter="filter"
          :sort-by.sync="sortBy"
          :sort-desc.sync="sortDesc"
          :sort-direction="sortDirection"
          @filtered="onFiltered"
          show-empty>
          <template slot="stackname" slot-scope="row">
            <router-link tag="a" :to="{path: '/stacks/timeline', query: { stacknamehistory: itemsstacks[row.index].stackname }}" key="link_stackusage">
                <span v-text="row.item.stackname">
                </span>
            </router-link>
          </template>
          <template slot="actions" slot-scope="row">
            <b-button  variant="primary" size="sm" v-if="row.item.status == 'Avaliable'"  @click="myRowClickHandler(row.item)" class="mr-1" 
              :disabled="$session.get('stackname') != ''" >
              Get Stack 
            </b-button>
            <b-button  variant="primary" size="sm" v-else  @click="myRowClickHandlerFree(row.item)" class="mr-1" 
              :disabled="$session.get('role') != 'admin' && $session.get('stackname') != row.item.stackname " >
              Free Stack 
            </b-button>
            
          </template>
        </b-table>
        <b-pagination align="right" size="sm" :total-rows="totalstackentries" v-model="currentPage" :per-page="5" />
    </b-row>

  </b-container>
    </div>
</template>
<script>
import http from "../http-common";
import { mapGetters,  mapActions } from 'vuex'
export default {
	name:'Stacks',
	data() {
    return {
      user:{
          username:'',
          purpose:'',
          frontendBranch:'',
          backendBranch:'',
          stackname:''
        },
        userdata: {
          username: '',
          stackname: ''
        },
      itemsstacks: [],
      fieldsstack: [{ key: 'stackname', label: 'Stack Name', sortable: true, clickable:true },
          { key: 'status', label: 'Status', sortable: true },
          { key: 'actions', label: 'Actions', sortable: false }],
      newstackname:'',
      totalstackentries: 1,
      currentPage:1,
      form: {
          purpose:'',
          FEBranch:'',
          BEBranch:''
        },
      show:false,
      stacknamehistory:'',
      sortBy: null,
      filter: null,
      sortDesc: false,
      sortDirection: 'asc',
      filterget:'',
      none:"none",
      sortOptions:[
          { value: 'Avaliable', text: 'Avaliable' },
          { value: 'Not Avaliable', text: 'Not Avaliable' }],
      send_message: null,
      connected: false,
      stompvalue:''
    };
  },
  methods: {
    ...mapActions([
              'send_actions',
              'commitstackname'
            ]),
    send(val) {
      var msg={message:val ,url:"/topic/greetings"}
        this.send_actions(msg)
    },
    onFiltered(filteredItems) {
        this.totalstackentries = filteredItems.length
        this.currentPage = 1
      },
    async onSubmit(evt) {
        evt.preventDefault()
        this.user['purpose'] = this.form.purpose;
        this.user['frontendBranch'] = this.form.FEBranch;
        this.user['backendBranch'] = this.form.BEBranch;
        await this.getstack();
        this.form.purpose = '';
        this.form.FEBranch = '';
        this.form.BEBranch = '';
      },
      onReset(evt) {
        evt.preventDefault()
        this.form.purpose = '';
        this.form.FEBranch = '';
        this.form.BEBranch = '';
        this.status='';
      },
      clearName() {
        this.user['purpose'] = '';
        this.user['FEBranch'] = '';
        this.user['BEBranch'] = '';
      },
    myRowClickHandler(record) {
        this.user['stackname']=record['stackname'];
        this.$refs.myModalRef1.show();
        
      },
    async myRowClickHandlerFree(record){
      if(this.$session.get("role")!="admin" && this.$session.get("stackname")==record['stackname']){
        await this.releasestack(this.$session.get("username"),record['stackname']);
        var send1={message:"Free Stack:"+record['stackname'],url:'/app/hello'}
        await this.send_actions(send1) 
      }else{
        await this.releasestackbyadmin(record['stackname']);
        var send2={message:"Free Stack:"+record['stackname'],url:'/app/hello'}
        await this.send_actions(send2)
      }
      await this.retrieveAllStacks();
      await this.gettotalstackentries();
      
    },
    async releasestack(username,stackname) {
        this.userdata['username']=username
        this.userdata['stackname']=stackname
        await http
        .post("/releasestack", this.userdata)
        .catch(e => {
          console.log(e);
        });
    },
    async releasestackbyadmin(stackname) {
        await http
        .post("/releasestackbyadmin", stackname)
        .catch(e => {
          console.log(e);
        });
    },
    clearNewName() {
        this.newstackname='';
      },
    handleSubmit() {
        this.clearName()
        this.$nextTick(() => {
          this.$refs.myModalRef.hide()
        })
      },
    async getfilter(filter){
      await http
          .post("/getfilterstack", filter)
          .then(response => {
              this.itemsstacks = response.data;
          })
        .catch(e => {
            console.log(e);
          });
    },
    async retrieveAllStacks() {
      await http
        .get("/stacksall")
        .then(response => {
          this.itemsstacks = response.data;
        })
        .catch(e => {
          console.log(e);
        });
    },
    addstack(){
    	this.$refs.myModalRef.show();
    },
    addstacktodb(){

    	 http
        .post("/addstack", this.newstackname)
  	    .catch(e => {
            console.log(e);
          });
      	this.handleSubmit();
        this.send("ddstacktodb");
    },
    async gettotalstackentries(){
    	await http
	        .get("/stackscount")
	        .then(response => {
	        	this.totalstackentries=response.data;
	        })
		    .catch(e => {
	          console.log(e);
	        });
    },
    async getstack(){
        await http
        .post("/getstack", this.user)
        .then(response => {
          if(response.data!="Done"){
                this.status=response.data
                this.show=true
          }else{
          this.$session.set('stackname',this.user['stackname'])
          this.commitstackname(this.user['stackname'])
          this.$refs.myModalRef1.hide()
          var send3="Get Stack:"+this.user['stackname']
          this.send(send3)
          }        
        })
        .catch(e => {
          console.log(e);
        });
        this.retrieveAllStacks();
      },
      async getstackusedname() {
            
            await http
            .post("/used",this.$session.get("username"))
            .then(response => {
              
              if(response.data.length == 0){
                this.commitstackname("")
                this.$session.set("stackname",'');
              }else{
                this.commitstackname(response.data[0]['stackname'])
                this.$session.set("stackname",response.data[0]['stackname']);
              }
            })
            .catch(e => {
              console.log(e);
            });
          },
      ...mapActions([
              'commitactivetab'
      ]),
      setactivetab: function(value) {
            this.commitactivetab(value)
      },

  },
  computed: {
      ...mapGetters([
      'getreceived_messages_store',
      'getactivetab'
      ]),

    },
    watch: {
      getreceived_messages_store:async function (val){
        if(val.content_type=="stack_changes"){
          await this.getstackusedname();
          await this.gettotalstackentries();
          await this.retrieveAllStacks();
        }
      },
    currentPage: function (val) {
      this.setactivepagesquad(val);
    },
    filterget:function(val){
      this.getfilter(val);
    }
  },
  created() {
    this.setactivetab(2)
    this.retrieveAllStacks();
    this.gettotalstackentries();
    this.user['username']=this.$session.get('username');
  },
  mounted() {
    this.retrieveAllStacks();
    this.gettotalstackentries();
    this.user['username']=this.$session.get('username');
  }
}
</script>
<style >
.card-title{
  margin: 0;
  color: #958170;
  font-weight: 300;
  font-size: 22px;
  line-height: 30px;
}
.header-card{
  margin-bottom: 20px;
  width: 100%;
}

.header-card button{
  margin: 5px;
}    
.card-category{
  font-size: 14px;
  font-weight: 400;
  color: #9a9a9a;
  margin-bottom: 0;
}
.app-normal-table thead th{
  position: relative;
  word-wrap: normal;
  text-overflow: ellipsis;
  vertical-align: middle;
  font-size: 14px;
  font-weight: 500;
  color: #909399;
  border-bottom: none;
}
.app-normal-table tbody td{
  box-sizing: border-box;
  white-space: normal;
  word-break: break-all;
  line-height: 23px;
  text-overflow: ellipsis;
  padding-right: 10px;
  overflow: hidden;
  font-weight: 300;
  font-size: 14px;
  color: #606266;
}
.app-normal-table tbody tr:nth-of-type(odd){
  background-color: rgba(0,0,0,.05);
}
.app-normal-table tbody tr:nth-of-type(even){
  background-color: #fff;
}
.hide-top-border tr th{
  border-top:none;
}

</style>